import { destroy, get, post } from '@/utils/fetch'
import type { TInvite, TInvitePublicInfo } from '@/interfaces/invite'

export const getInviteById = async (id: string) => {
  const invite = await get<TInvitePublicInfo>(`/invite/my?id=${id}`)
  return invite
}

export const getInviteList = async () => {
  const inviteList = await get<TInvitePublicInfo[]>('/invite/my/list')
  return inviteList
}

export const createInvite = async (data: Partial<TInvite>) => {
  const result = await post<TInvitePublicInfo>('/invite/my', data)
  return result
}

export const removeInvite = async (id: string) => {
  const result = await destroy<TInvitePublicInfo>(`/invite/my?id=${id}`)
  return result
}

export const acceptInvite = async (id: string) => {
  const result = await post<TInvitePublicInfo>('/invite/accept', { id })
  return result
}

export const rejectInvite = async (id: string) => {
  const result = await post<TInvitePublicInfo>('/invite/reject', { id })
  return result
}

export const getPendingInvite = async () => {
  const result = await get<{ invite: TInvitePublicInfo | null }>('/invite/pending')
  return result
}
